import WooCommerce from "@/services/wooservice.js";
import { groupCategoryIds } from "../../helpers/categoryTree";
import { divideArray } from "@/helpers/utils";

const state = {
  products: {
    data: [],
    totalPages: 1,
  },
  filters: {
    orderby: "price",
    order: "desc",
  },
  filteredProducts: {
    data: [],
    totalPages: -1,
  },
  isFetching: false,
};

const getters = {
  products: () => state.products.data,
  productsPages: () => state.products.totalPages,
  filteredProducts: () => state.filteredProducts.data,
  filteredProductsPages: () => state.filteredProducts.totalPages,
  filters: () => state.filters,
  isFetching: () => state.isFetching,
};

const actions = {
  getProducts({ commit, getters }, page = 1) {
    commit("setIsFetching", true);
    WooCommerce.get("products", {
      ...getters.filters,
      per_page: 24,
      page,
    }).then((response) => {
      const totalPages = +response.headers["x-wp-totalpages"];
      commit("setProducts", { data: response.data, page, totalPages });
      commit("setIsFetching", false);
    });
  },

  async getFilteredProducts({ commit, getters, rootGetters }, payload) {
    commit("setIsFetching", true);

    const categoryTree = rootGetters["categories/categoryTree"];
    const { categories, min_price, max_price, order, orderby } = {
      ...getters.filters,
      ...(payload?.filters && payload?.filters),
    };

    const filterParams = {
      ...(categories?.length ? { category: categories.join(",") } : {}),
      order,
      orderby,
      min_price,
      max_price,
      per_page: 24,
    };

    const groupedFilterCategories = groupCategoryIds(categoryTree, categories);

    try {
      let filtered = [];
      let totalPages;
      let page = payload?.page || 1;

      if (categories?.length > 1) {
        page = 1;

        do {
          const res = await WooCommerce.get("products", {
            ...filterParams,
            per_page: 99,
            page,
          });

          filtered = [...filtered, ...res.data];
          page += 1;
          totalPages = +res.headers["x-wp-totalpages"];
        } while (page < totalPages);

        filtered = filtered.filter((product) => {
          const productCategorIds = product.categories.map(
            (category) => category.id
          );

          const results = Object.keys(groupedFilterCategories)
            .filter((key) => key !== "0")
            .map((key) => {
              return productCategorIds.filter((catId) => {
                return groupedFilterCategories[key].includes(catId);
              }).length
                ? true
                : false;
            });

          return results.every((result) => result === true);
        });

        totalPages = divideArray(filtered, filterParams.per_page).length;

        commit("setFilteredProducts", {
          products: divideArray(filtered, filterParams.per_page),
          totalPages,
        });
      } else {
        const res = await WooCommerce.get("products", {
          ...filterParams,
          page,
        });
        totalPages = +res.headers["x-wp-totalpages"];
        filtered = res.data;
        commit("setFilteredProducts", {
          products: filtered,
          totalPages,
          page,
        });
      }

      commit("setIsFetching", false);
    } catch (err) {
      commit("setIsFetching", false);
      console.log(err);
    }
  },
};

const mutations = {
  setProducts(state, { data, page, totalPages }) {
    if (data) {
      state.products.totalPages = totalPages;
      state.products.data[page - 1] = data; //массив приходит с сервака перевернутым
    }
  },

  setFilters(state, filters) {
    if (filters) {
      state.filters = {
        ...state.filters,
        ...filters,
      };
    }
  },

  setFilteredProducts(state, { products, totalPages, page }) {
    state.filteredProducts.totalPages = totalPages;
    if (page) {
      state.filteredProducts.data[page - 1] = products;
    } else {
      state.filteredProducts.data = products;
    }
  },

  setIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },

  clearFilteredProducts(state) {
    state.filteredProducts = {
      data: [],
      totalPages: -1,
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
